import type { BadgeSeverityType } from '../components/styled/badge-severity';
import { Badge } from '../components/badge';
import { BadgeSeverity } from '../components/styled/badge-severity';
import { Text } from '../components/styled/text';

export const METHOD_SEVERITY: Record<string, BadgeSeverityType> = {
  GET: 'Low',
  HEAD: 'Low',
  OPTIONS: 'Low',
  POST: 'Medium',
  PATCH: 'Medium',
  PUT: 'High',
  DELETE: 'Critical',
};

export const getMethodSeverity = (
  method?: string,
): BadgeSeverityType | null => {
  if (!method) return null;

  return METHOD_SEVERITY[method.toUpperCase()] ?? null;
};

export const getStatusSeverity = (
  status?: number,
): BadgeSeverityType | null => {
  if (!status) return null;

  if (status >= 200 && status < 300) return 'Low';
  if (status >= 300 && status < 400) return 'Medium';
  if (status >= 400 && status < 500) return 'High';
  if (status >= 500) return 'Critical';

  return null;
};

export function renderHttpBadge(value: string | number) {
  const severity =
    typeof value === 'number'
      ? getStatusSeverity(value)
      : getMethodSeverity(value);

  return severity ? (
    <BadgeSeverity severity={severity} size="sm">
      {value}
    </BadgeSeverity>
  ) : (
    <Badge size="sm" variant="fill">
      {value}
    </Badge>
  );
}

export function renderHttpMethodText(value: string | number) {
  const display =
    typeof value === 'number' ? String(value) : value.toUpperCase();

  return (
    <Text fontSize="xs" fontFamily="mono" color="fg.muted" flexShrink={0}>
      {display}
    </Text>
  );
}
